import { Card, Row, Col } from "antd";
import teamsData from "../../assets/data/teams.json";

import core from "../../assets/icons/core.png";
import APIOps from "../../assets/icons/APIOps.png";
import DataOps from "../../assets/icons/DataOps.png";
import GenAI from "../../assets/icons/GenAI.png";
import SRE from "../../assets/icons/SRE.png";
import container from "../../assets/icons/container.png";

const FocusAreas = () => {
  const imageMap = {
    "Core DevOps": core,
    "Modern DevXOps": container,
    "DataOps/MLOps": DataOps,
    "Platform Engineering": APIOps,
    "AI Drivern DevXOps": GenAI,
    "Site Reliability Engineering (SRE)": SRE,
  };

  return (
    <div className="py-10">
      <h2 className="text-2xl font-bold mb-6">Our Specializations</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {teamsData.map((area, index) => {
          const image = imageMap[area.teamName] || core;
          return (
            <div key={index} className="flex">
              <div className="flex flex-col w-full bg-white  p-4 rounded h-full min-h-[260px]">
                <div className="flex items-start">
                  <img
                    src={image}
                    className="h-10 w-10 flex-shrink-0"
                    alt={area.teamName}
                  />
                  <h3 className="font-medium text-xl ml-4 mt-1 break-words">
                    {area?.teamName}
                  </h3>
                </div>
                <p className="mt-2 text-lg font-normal ">{area?.teamSummary}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FocusAreas;
